import React from 'react';

import './button.css';

export default (props) =>
  <button className={`btn ${props.state}`} onClick={props.onClick}>
    <span className={`mdi mdi-${props.icon}`}></span>
    {props.label}
  </button>
